var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.documents.length && !_vm.isAdding
      ? _c("div", { staticClass: "bg-secondary-3 p-3 mt-4 rounded" }, [
          _c("div", [
            _c("div", { staticClass: "upload-file-button__container" }, [
              _c("div", { staticClass: "panel-row-without-selector p-4" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  !_vm.readOnly
                    ? _c(
                        "button",
                        {
                          staticClass: "btn bg-light-white col-12 col-md-4",
                          on: {
                            click: function($event) {
                              _vm.isAdding = true
                            }
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "fas fa-file-plus pr-4 text-green"
                          }),
                          _c(
                            "span",
                            { staticClass: "text-button-add-document" },
                            [_vm._v(" Presione aquí para anejar documento ")]
                          )
                        ]
                      )
                    : _c("div", { staticClass: "text-center" }, [
                        _c("strong", [_vm._v("No hay documentos anejados")])
                      ])
                ])
              ])
            ])
          ])
        ])
      : _c(
          "div",
          _vm._l(_vm.documents, function(document, index) {
            return _c("add-document-row", {
              key: index,
              attrs: {
                document: document,
                index: index,
                "read-only": _vm.readOnly
              },
              on: { "on-download": _vm.onDownload, "on-remove": _vm.onRemove }
            })
          }),
          1
        ),
    _vm.isAdding
      ? _c(
          "div",
          { staticClass: "bg-secondary-3 p-3 mt-3 rounded" },
          [
            _c(
              "validation-observer",
              {
                ref: "documentObserver",
                staticClass: "row mx-2",
                attrs: { tag: "div" }
              },
              [
                _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-6" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  class: {
                                    "was-Invalidated-select": !!errors[0]
                                  },
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Tipo de Documento:",
                                    options: _vm.availableDocumentTypes,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.model.documentType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "documentType", $$v)
                                    },
                                    expression: "model.documentType"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3887272092
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-md-4 col-sm-6",
                    class: _vm.model.file && "d-flex justify-content-center"
                  },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-file-input", {
                                  ref: "fileUpload",
                                  staticClass: "mt-4 pt-1",
                                  attrs: {
                                    accept: _vm.allowedFiles,
                                    "custom-error-msg":
                                      "Favor seleccionar un documento.",
                                    "display-style": "normal",
                                    error: errors[0],
                                    label: "",
                                    "label-position": "left",
                                    "max-size": 100,
                                    "on-download": () => {},
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.model.file,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "file", $$v)
                                    },
                                    expression: "model.file"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        504317259
                      )
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "mt-4 text-right" },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            id: "btnCancel",
                            i: "fas fa-times-circle",
                            variant: "outline-danger btn-cancel danger m-2"
                          },
                          on: { click: _vm.closeAdding }
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "action-button",
                        {
                          attrs: {
                            id: "btnAdd",
                            i: "fas fa-file-plus",
                            variant: "success pl-4 pr-4"
                          },
                          on: { click: _vm.onAdd }
                        },
                        [_vm._v(" Añadir ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.documents.length > 0 && !_vm.isAdding && !_vm.readOnly
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-end mt-3" },
          [
            _c(
              "action-button",
              {
                attrs: { i: "fas fa-file-plus", variant: "success" },
                on: {
                  click: function($event) {
                    _vm.isAdding = true
                  }
                }
              },
              [_vm._v(" Añadir ")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }